// API endpoint - w produkcji użyj względnej ścieżki (ten sam host)
// W development użyj localhost
const API_URL = process.env.REACT_APP_API_URL || (
  process.env.NODE_ENV === 'production' 
    ? '/api'  // W produkcji używaj względnej ścieżki (ten sam host)
    : 'http://localhost:5000/api'  // W development użyj localhost
);

// Funkcja pomocnicza do wykonywania requestów
export const apiRequest = async (endpoint, options = {}) => {
  const token = localStorage.getItem('authToken');
  
  const config = {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token && { 'Authorization': `Bearer ${token}` }),
      ...options.headers,
    },
  };

  try {
    const response = await fetch(`${API_URL}${endpoint}`, config);
    
    // Sprawdź czy odpowiedź to JSON
    let data;
    const contentType = response.headers.get('content-type');
    if (contentType && contentType.includes('application/json')) {
      data = await response.json();
    } else {
      const text = await response.text();
      throw new Error(text || 'Błąd serwera');
    }
    
    if (!response.ok) {
      // Jeśli błąd 401 lub 403, może token wygasł
      if (response.status === 401 || response.status === 403) {
        // Sprawdź czy komunikat błędu wskazuje na problem z tokenem
        const isTokenError = data.error && (
          data.error.includes('token') || 
          data.error.includes('wygasł') || 
          data.error.includes('Nieprawidłowy') ||
          data.error.includes('autoryzacji')
        );
        
        // Tylko dla endpointu /auth/verify usuwamy token zawsze
        if (endpoint === '/auth/verify') {
          localStorage.removeItem('authToken');
          localStorage.removeItem('user');
          throw new Error('Sesja wygasła. Zaloguj się ponownie.');
        }
        
        // Dla innych endpointów, usuń token tylko jeśli to błąd związany z tokenem
        if (isTokenError) {
          // Nie usuwaj tokenu od razu - pozwól użytkownikowi zobaczyć komunikat
          // Token zostanie usunięty gdy użytkownik spróbuje się wylogować lub odświeżyć
          throw new Error(data.error || 'Sesja wygasła. Zaloguj się ponownie.');
        }
        
        // Dla innych błędów 401/403 (np. brak uprawnień), nie usuwaj tokenu
        throw new Error(data.error || 'Brak uprawnień do wykonania tej operacji.');
      }
      throw new Error(data.error || `Błąd serwera (${response.status})`);
    }
    
    return data;
  } catch (error) {
    // Jeśli to błąd sieci, dodaj więcej informacji
    if (error.name === 'TypeError' && error.message.includes('fetch')) {
      throw new Error('Nie można połączyć się z serwerem. Sprawdź czy backend działa.');
    }
    throw error;
  }
};

// API dla autentykacji
export const authAPI = {
  // Logowanie
  login: async (email, password) => {
    const data = await apiRequest('/auth/login', {
      method: 'POST',
      body: JSON.stringify({ email, password }),
    });
    
    // Zapisz token
    if (data.token) {
      localStorage.setItem('authToken', data.token);
      localStorage.setItem('user', JSON.stringify(data.user));
    }
    
    return data;
  },

  // Rejestracja
  register: async (email, password, name, role = 'user', projects = []) => {
    const data = await apiRequest('/auth/register', {
      method: 'POST',
      body: JSON.stringify({ email, password, name, role, projects }),
    });
    
    // Zapisz token
    if (data.token) {
      localStorage.setItem('authToken', data.token);
      localStorage.setItem('user', JSON.stringify(data.user));
    }
    
    return data;
  },

  // Weryfikacja tokenu
  verify: async () => {
    try {
      return await apiRequest('/auth/verify');
    } catch (error) {
      // apiRequest już usunął token dla /auth/verify jeśli był błąd 401/403
      // Tutaj tylko rzucamy błąd dalej
      throw error;
    }
  },

  // Wylogowanie
  logout: () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
  },

  // Sprawdź czy użytkownik jest zalogowany
  isAuthenticated: () => {
    return !!localStorage.getItem('authToken');
  },

  // Pobierz aktualnego użytkownika z localStorage
  getCurrentUser: () => {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  }
};

export default authAPI;



